import Nullstack from 'nullstack';
export default function IconSocial({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-social",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "5",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "5",
    cy: "19",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "19",
    cy: "19",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "14",
    r: "3"
  }), "   ", Nullstack.element("line", {
    x1: "12",
    y1: "7",
    x2: "12",
    y2: "11"
  }), "   ", Nullstack.element("line", {
    x1: "6.7",
    y1: "17.8",
    x2: "9.5",
    y2: "15.8"
  }), "   ", Nullstack.element("line", {
    x1: "17.3",
    y1: "17.8",
    x2: "14.5",
    y2: "15.8"
  }), " ");
}